import { useContext } from 'react';
import { AnalyticsContext, AnalyticsAPI } from './AnalyticsContext';

export const useAnalyticsContext = (): AnalyticsAPI => {
  const analytics = useContext(AnalyticsContext);
  if (!analytics) {
    throw Error('Trying to use AnalyticsContext outside of provider.');
  }
  return analytics;
};
